import { styled, Grid, Paper, Box } from '@mui/material'

export const StyledImage = styled('img')({
  objectFit: 'cover',
  width: '100%',
  height: '100%'
})

export const StyledGrid = styled(Grid)(({ theme }) => ({
  overflow: 'hidden',
  minHeight: '500px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'relative',
  ['&.overlay:before']: {
    content: '""',
    display: 'block',
    width: '100%',
    height: '100%',
    position: 'absolute',
    left: 0,
    top: 0,
    background: 'rgba(0, 0, 0, 0.5)'
  },
  [theme.breakpoints.down('md')]: {
    minHeight: '250px'
  }
}))

export const StyledFormWrapper = styled(StyledGrid)({
  padding: '30px',
  flexDirection: 'column',
  display: 'flex'
})

export const StyledPaperRoot = styled(Paper)({
  overflow: 'hidden',
  borderRadius: '20px',
  boxShadow: '0 0 40px 10px rgba(0, 0, 0, 0.1)'
})

export const StyledLoginWrap = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  transition: 'all .3s ease',
  ['&.hidden']: {
    opacity: 0.5,
    pointerEvents: 'none',
    filter: 'grayscale(1)'
  }
}))
